
import Shuffle from './__shuffle';

import * as slick from 'slick-carousel/slick/slick.js';

$(document).ready(function() {

	// nav bar behaviour
	var $nav_brand = $('.navbar-brand');
	var $nav_bar = $('.navbar-nav');
	$nav_brand.addClass('hidden');
	$(window).scroll(function () {
		if ($(this).scrollTop() > 125) {
			$nav_brand.removeClass('hidden');
			$nav_bar.addClass('pe-lg-5 me-lg-5');
		}
		else {
			$nav_brand.addClass('hidden');
			$nav_bar.removeClass('pe-lg-5 me-lg-5');
		}
	});

	// ARTICLE IMAGES (SHUFFLE)
	var $shuffles = $('.art-shuffle');
	if ($shuffles.length > 0) {

		$shuffles.each(function() {
			new Shuffle($(this), {
				itemSelector: '.shuffle-item',
				sizer: '.shuffle-sizer',
				buffer: 1,
			});
		});

	}

	// ARTICLE IMAGES (SLIDER)
	var $slides = $('.ab-imgs-carousel');
	if ($slides.length > 0) {

		$slides.each(function() {
			$(this).slick({
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				centerMode: true,
				variableWidth: true
			});
		});

	}

	// SERVICE/PRACTITIONER FILTERS & SHUFFLE
	if ($('.js-shuffle').length > 0) {

		var $shuffle = new Shuffle(document.querySelector('.js-shuffle'), {
			itemSelector: '.shuffle-item',
			sizer: '.shuffle-sizer',
			buffer: 1,
		});

		if ($('.service, .practitioners').length > 0) {
			// handle filtering
			$('body').on('click', '.shuffle-filter', function() {
				if ($(this).hasClass('btn-active')) return;
				$(this).addClass('btn-active')
					.parents('.slick-slide').siblings().find('.btn').removeClass('btn-active');
				$shuffle.filter($(this).attr('data-filter'));
			});
			$('.service .slick-slider').slick({
				arrows: true,
				infinite: false,
				speed: 300,
				slidesToShow: 14,
				slidesToScroll: 8,
				responsive: [
					{
						breakpoint: 1600,
						settings: {
							slidesToShow: 12,
							slidesToScroll: 8
						}
					},
					{
						breakpoint: 1400,
						settings: {
							slidesToShow: 10,
							slidesToScroll: 8
						}
					},
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 8,
							slidesToScroll: 8
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 6,
							slidesToScroll: 6
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 4
						}
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					}
				]
			});
			$('.practitioners .slick-slider').slick({
				arrows: true,
				infinite: false,
				speed: 300,
				slidesToShow: 10,
				slidesToScroll: 8,
				responsive: [
					{
						breakpoint: 1600,
						settings: {
							slidesToShow: 9,
							slidesToScroll: 8
						}
					},
					{
						breakpoint: 1400,
						settings: {
							slidesToShow: 8,
							slidesToScroll: 8
						}
					},
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 6,
							slidesToScroll: 6
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 5,
							slidesToScroll: 5
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3
						}
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					}
				]
			});
			var $no_results = $('.no-results');
			$shuffle.on(Shuffle.EventType.LAYOUT, () => {
				if ($('.shuffle-item:visible').length === 0) $no_results.removeClass('d-none');
				else $no_results.addClass('d-none');
			});

			$(window).on('resize', function() {
				$('header.sticky-top').css('top', $('#global-nav').innerHeight() + 'px');
			});

			$(window).trigger('resize');
		}

	}

	// PRACTITIONER PROFILE ARTICLES SLIDER
	var $art_slider = $('.articles-slider');
	if ($art_slider.length > 0) {

		$art_slider.slick({
			arrows: true,
			infinite: false,
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				},
			]
		});

	}

	// PRACTITIONER PROFILE REVIEWS SLIDER
	var $rev_slider = $('.reviews-slider');
	if ($rev_slider.length > 0) {

		$rev_slider.slick({
			dots: true,
			arrows: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 8000,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
		});

	}

	// STAFF REVIEWS (REQUEST)
	var $srr_form = $('form#request-review');
	if ($srr_form.length > 0) {

		$srr_form.on('submit', function(e) {

			e.preventDefault();

			if ($srr_form.hasClass('disabled')) return false;
			$srr_form.addClass('disabled');

			$.ajax({
				method: 'post',
				url: window.location.href,
				data: $srr_form.serialize(),
				dataType: 'json'
			}).done(function(data) {

				if (data.status === 'success') {
					if (typeof data.redirect !== 'undefined') window.location.replace(data.redirect);
					else window.location.reload(true);
				} else {
					alert(data.message);
					$srr_form.removeClass('disabled');
				}

			}).fail(function() {
				alert('Ajax post failed.');
				$srr_form.removeClass('disabled');
			});

		})

	}

	// STAFF REVIEWS (GIVE)
	var $srg_form = $('form#give-review');
	if ($srg_form.length > 0) {

		$srg_form.on('submit', function(e) {

			e.preventDefault();

			if ($srg_form.hasClass('disabled')) return false;
			$srg_form.addClass('disabled');

			$.ajax({
				method: 'post',
				url: window.location.href,
				data: $srg_form.serialize(),
				dataType: 'json'
			}).done(function(data) {

				if (data.status === 'success') {
					$srg_form.find('.before-submit').addClass('d-none');
					$srg_form.find('.after-submit').removeClass('d-none');
				} else {
					alert(data.message);
					$srg_form.removeClass('disabled');
				}

			}).fail(function() {
				alert('Ajax post failed.');
				$srg_form.removeClass('disabled');
			});

		})

	}

	// OPPORTUNITIES STAGES
	var $os_btns = $('.change-stage');
	if ($os_btns.length > 0) {
		$os_btns.click(function() {
			$(this).closest('.os-panel').addClass('d-none');
			$($(this).attr('data-next-target')).removeClass('d-none');
		});
	}

	// OPPORTUNITY SUBMISSIONS
	var $op_form = $('form#op_form');
	if ($op_form.length > 0) {

		$op_form.on('submit', function(e) {

			e.preventDefault();

			if ($op_form.hasClass('disabled')) return false;
			$op_form.addClass('disabled');

			var $btn = $op_form.find('button[type="submit"]');
			var $errors = $op_form.find('.form-errors');
			$errors.html('').addClass('d-none');
			$btn.addClass('disabled').attr('data-btn-text', $btn.text()).text('Sending...');

			var formData = new FormData(this); // Use FormData to handle file uploads

			$.ajax({
				method: 'post',
				url: window.location.href,
				data: formData,
				dataType: 'json',
				processData: false, // Prevent jQuery from processing the data
				contentType: false, // Prevent jQuery from setting the Content-Type header
			}).done(function(data) {

				if (data.status === 'success') {
					$op_form.hide();
					$('#op_thanks').removeClass('d-none');
				} else {
					$errors.html(data.message).removeClass('d-none');
					$op_form.removeClass('disabled');
					$btn.removeClass('disabled').text($btn.attr('data-btn-text'));
				}

			}).fail(function() {
				$errors.html('Ajax post failed.').removeClass('d-none');
				$op_form.removeClass('disabled');
				$btn.removeClass('disabled').text($btn.attr('data-btn-text'));
			});

		})

	}

	// FILE INPUT MASKING
	var $input_file_mask = $('.input-file-mask');
	if ($input_file_mask.length > 0) {
		$input_file_mask.click(function() {
			$($(this).attr('data-target-field')).click();
			$(this).removeClass('btn-outline-primary')
				.addClass('btn-primary')
				.html('Change File');
		});

	}
	// CRISP LIVE CHAT TRIGGER
	if (typeof $crisp !== 'undefined') {
		$('.crisp-trigger').on('click', function() {
			$crisp.push(["do", "chat:open"]);
		});
	}


});
